var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocumentForm = function SvgDocumentForm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6180",
    "data-name": "Grupo 6180",
    transform: "translate(-719 -110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-prescription-188422",
    transform: "translate(697.619 85.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7875",
    "data-name": "Caminho 7875",
    d: "M91.2,47.2,71.955,27.955a2.437,2.437,0,0,0-1.725-.714H42.042A10.673,10.673,0,0,0,31.381,37.9V90.583A10.672,10.672,0,0,0,42.042,101.24l39.21,0A10.674,10.674,0,0,0,91.918,90.579V48.925A2.447,2.447,0,0,0,91.2,47.2ZM72.669,35.564,83.592,46.487H78.458A5.793,5.793,0,0,1,72.669,40.7ZM87.04,90.578a5.792,5.792,0,0,1-5.789,5.781l-39.21,0a5.79,5.79,0,0,1-5.784-5.781V37.9a5.791,5.791,0,0,1,5.784-5.782h25.75V40.7A10.675,10.675,0,0,0,78.456,51.364h8.582V90.578ZM45.033,49.75h3.986v4a2.438,2.438,0,1,0,4.877,0v-4h3.986a2.438,2.438,0,1,0,0-4.877H53.9v-3.98a2.438,2.438,0,1,0-4.877,0v3.98H45.033a2.438,2.438,0,0,0,0,4.877ZM78.265,73.131H45.033a2.438,2.438,0,0,0,0,4.877H78.265a2.438,2.438,0,1,0,0-4.877ZM45.033,62.919a2.438,2.438,0,0,0,0,4.877H78.265a2.438,2.438,0,1,0,0-4.877ZM78.265,83.344H45.033a2.438,2.438,0,0,0,0,4.877H78.265a2.438,2.438,0,1,0,0-4.877Z",
    transform: "translate(0 0)",
    fill: "#1f35b5",
    strokeWidth: 2
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocumentForm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document-form.fb195c79.svg";
export { ForwardRef as ReactComponent };